import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthguardGuard } from './authguard.guard';
import { BlankComponent } from './blank/blank.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { WorkspaceResolve } from './shared/Workspace.resolve';

const appRoutes: Routes = [
  // {path: 'form', component: GenerateformurlComponent },
  {
    path: 'form',
    loadChildren: () => import('./forms/forms.module').then(m => m.FormsModule)
  },
  // P6-WP10: the external recipient's answer page — public, no sign-in (same pattern as `form`).
  {
    path: 'agent-answer',
    loadChildren: () => import('./agent-answer/agent-answer.module').then(m => m.AgentAnswerModule)
  },
  {
    path: ':tenant-id/cloudautomation', canActivate: [AuthguardGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    resolve: { workspaceOptions: WorkspaceResolve }
  },
  // { path:'tenants',canActivate: [AuthguardGuard], loadChildren:'./master/master.module#MasterModule'},
  {
    path: 'platformadmin', canActivate: [AuthguardGuard],
    loadChildren: () => import('./platformadmin/platformadmin.module').then(m => m.PlatformadminModule)
  },
  { path: '', component: BlankComponent },
  { path: '**', component: NotFoundComponent }
];



@NgModule({
  // NOTE: `onSameUrlNavigation` is intentionally left at its default ('ignore').
  // A global 'reload' made every repeated same-URL navigation re-run
  // WorkspaceResolve (MyWorkspaces / CheckBYOKStatus) and re-create the dashboard
  // components, multiplying API calls on load. The topbar's workspace switch
  // asks for a reload on its own navigation only (and rebuilds that page once),
  // so that flow still refreshes correctly.
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
